module.exports = __webpack_public_path__ + "static/img/Sam-Taylor.e4a86bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Taylor.jpg
// module id = UVqP
// module chunks = 0